import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useIdempotentAppMutation } from '../use-idempotent-app-mutation.hook';

export const useExpire = () => {
  const { mutate: create, isPending } = useIdempotentAppMutation([QueryKey.EXPIRE], {
    mutationFn: (
      {
        companyId,
        data,
      }: {
        companyId: string;
        data: { filesLinks?: string[]; value: number; vestingTaskId: string }[];
      },
      { headers },
    ) =>
      ApiService.post(
        { endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'events', 'expire'] },
        { body: data, headers },
      ),
  });

  return { create, isPending };
};
